<div class="next-processing-position-editor">
    <div class="row">
        <mat-form-field class="mat-form-field-readonly flex-grow">
            <input matInput [(ngModel)]="positionName"
            placeholder="{{'next processing position' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.next-processing-position-editor.next-processing-position', translationService.language]}}"
                [readonly]="true">
        </mat-form-field>

        <button mat-flat-button type="button" (click)="assignNextProcessingPosition()"
            class="small-button assign-button"><sc-icon iconClass="fa-sitemap"></sc-icon></button>
    </div>
</div>